import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { useMobile } from '@shared/hooks';
import { Card, ImageInputCropper, Textarea } from '@shared/ui';
import { fieldToUppercase } from 'library/helpers/events';
import * as st from './styles.module.scss';

export const Title = (): JSX.Element => {
  const {
    register,
    watch,
    formState: { errors },
    control,
    setValue,
    trigger,
  } = useFormContext();
  const { isMobile } = useMobile();

  const errorTitle = !!errors.title;
  const errorImage = !!errors.event_image;
  const tileValue = watch('title');
  const image = watch('event_image');

  return (
    <fieldset className={st.fieldset}>
      <Card className={st.title}>
        <div className={st.wrapper}>
          <div className={st.title__image}>
            <Controller
              control={control}
              name={`event_image`}
              render={({ field: { value } }) => (
                <ImageInputCropper
                  aspect={[16, 9]}
                  iconVariant="cover"
                  value={value as string}
                  onChange={(value) => {
                    value && setValue(`event_image`, value, { shouldDirty: image !== '' });
                    trigger('event_image');
                  }}
                  isValid={errorImage}
                />
              )}
            />
          </div>

          {!isMobile && (
            <div className={st.title__text_desktop}>
              <Textarea
                autosize
                {...register('title', {
                  onChange: (e) => (e.target.value = fieldToUppercase(e)),
                })}
                required={errorTitle}
              />
              {!tileValue && (
                <div className={st.placeholder}>
                  <span className={cn(st.placeholder__text, errorTitle && st.error)}>Название</span>
                  <span className={st.placeholder__sign}>*</span>
                </div>
              )}
            </div>
          )}
        </div>
      </Card>

      {isMobile && (
        <div className={st.titleMobile}>
          <h3>Название</h3>

          <Card className={st.titleMobile__card}>
            <div>
              <Textarea
                autosize
                {...register('title', {
                  onChange: (e) => (e.target.value = fieldToUppercase(e)),
                })}
                required={errorTitle}
              />
            </div>
          </Card>
        </div>
      )}
    </fieldset>
  );
};
